/* Manifest: ordene lyser opp etter hvert som setningen passerer skjermen,
 * og nøkkeltallene teller opp når de kommer til syne.
 *
 * Teksten deles i ord her, ikke i templaten, slik at markeringen er én lesbar
 * setning for skjermlesere og for besøkende uten JavaScript. */

import gsap from 'gsap';
import { $, $$, mindreBevegelse } from '../kjerne/verktoy.js';

function delIOrd(rot) {
  const gaGjennom = node => {
    if (node.nodeType === Node.TEXT_NODE) {
      const bit = document.createDocumentFragment();
      for (const del of node.textContent.split(/(\s+)/)) {
        if (!del.trim()) {
          bit.append(del);
          continue;
        }
        const s = document.createElement('span');
        s.className = 'manifest-ord'
          + (node.parentElement.hasAttribute('data-fremhev') ? ' fremhevet' : '');
        s.textContent = del;
        bit.append(s);
      }
      node.replaceWith(bit);
    } else {
      [...node.childNodes].forEach(gaGjennom);
    }
  };
  gaGjennom(rot);
}

function tellOpp() {
  for (const el of $$('[data-tell]')) {
    const mal = +el.dataset.tell;
    // Årstall skal ikke telle fra null; da ruller det i evigheter.
    const teller = { v: el.hasAttribute('data-fra-nesten') ? mal - 60 : 0 };
    el.textContent = String(teller.v);
    gsap.to(teller, {
      v: mal,
      duration: 2,
      ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 88%' },
      onUpdate: () => { el.textContent = String(Math.round(teller.v)); },
    });
  }
}

export function startManifest() {
  const tekst = $('#manifest-tekst');
  if (!tekst) return;

  if (mindreBevegelse.matches) {
    // Ingen oppdeling, ingen opptelling: alt står ferdig.
    return;
  }

  delIOrd(tekst);
  gsap.to('.manifest-ord', {
    opacity: 1,
    stagger: .1,
    ease: 'none',
    scrollTrigger: { trigger: tekst, start: 'top 80%', end: 'bottom 45%', scrub: true },
  });

  tellOpp();
  gsap.from('.tall-post', {
    y: 40, opacity: 0, duration: 1.1, ease: 'expo.out', stagger: .1,
    scrollTrigger: { trigger: '.tall', start: 'top 88%' },
  });
}
